import { IConfig } from './dynamic/config.model';
import { ArrowPosition, AttentionType } from '../types';

export const INFO_BUBBLE_TEXT_SIZES = ['small', 'medium'] as const;
export type InfoBubbleTextSize = (typeof INFO_BUBBLE_TEXT_SIZES)[number];

export interface IInfoBubble extends IConfig {
    textHtml: string;
    arrowPosition: ArrowPosition;
    attention: AttentionType;
    textSize: InfoBubbleTextSize;
}

/**
 * @deprecated Use `IInfoBubble` instead.
 */
export type InfoBubble = IInfoBubble;
